export class ApiError extends Error {
   extraData: any;
   constructor(message: string, extraData: any) {
      super(message);
      this.extraData = extraData;
   }
}
